import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { ITitleAssetUrlDTO } from '../../../../../api/assets.dao';
import DefaultButton from '../../../../global/default-button/default-button';
import { Popover } from '../../../../global/popover/popover';
import { CopyButton } from '../../../../global/copy-button/copy-button';
import { hasPermission } from '../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../api/roles.dao';
import { isFilePublic } from '../../../../../infrastructure/utils/file.utils';

import './asset-link-wrapper.scss';
import { DELETE_TEXT } from '../../../../../constants/common-labels.constants';

export interface IAssetLinkWrapperProps {
    isLinkCreating: boolean;
    file: ITitleAssetUrlDTO;
    createLink: (assetMetadataId: number, afterCreateLinkCb: () => void) => Promise<void>;
    deleteAssetDownloadLinkPermission: boolean;
    onDeleteAssetDownloadLink: (assetMetadataId: number) => void;
}

const AssetLinkWrapper = observer(({
    isLinkCreating,
    file,
    createLink,
    deleteAssetDownloadLinkPermission,
    onDeleteAssetDownloadLink
}: IAssetLinkWrapperProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    return (

        <div
            className='assets-create-file-wrapper'
            ref={wrapperRef}
        >
            {isLinkCreating
                ? <DefaultButton
                    text={<FormattedMessage
                        id='oe.asset.link.linkCreating'
                        description='Label'
                        defaultMessage='Creating Link'
                    />
                    }
                    className='asset-link-creating'
                    modifier='plus'
                />
                : isFilePublic(file)
                    ? <DefaultButton
                        text={<FormattedMessage
                            id='oe.assets.link.linkCreated'
                            description='Button text'
                            defaultMessage='Link Created'
                        />}
                        className={classnames('asset-link asset-link-created', {
                            'active': isOpen
                        })}
                        modifier='row'
                        onClick={() => setIsOpen(prev => !prev)}
                    />
                    : hasPermission(Permission.GENERATE_EVENT_ASSETS_PUBLIC_DOWNLOAD_LINK)
                        ? <DefaultButton
                            text={<FormattedMessage
                                id='oe.assets.link.createLink'
                                description='Button text'
                                defaultMessage='{prefix} Create Link'
                                values={{prefix: '+'}}
                            />}
                            className='asset-link visible-while-hovered'
                            modifier='plus'
                            onClick={() => createLink(
                                file.assetMetadataId,
                                () => setIsOpen(true))
                            }
                        />
                        : null
            }
            <Popover
                isOpen={isOpen}
                buttonRef={wrapperRef}
                withCloseIcon
                onClose={() => setIsOpen(false)}
                onClickOutside={() => setIsOpen(false)}
                customWidth={210}
                padding={0}
                align='start'
                position='top'
            >
                <div className='assets-create-file-info'>
                    <div className='assets-create-file-info__url'>
                        URL:
                    </div>
                    <div className='assets-create-file-info__link'>
                        { file.publicDownloadLink }
                    </div>
                    <div>
                        <CopyButton
                            copyValue={file.publicDownloadLink}
                            text={'Copy'}
                            withoutIcon
                            withCopyLink
                        />
                    </div>
                </div>
                {deleteAssetDownloadLinkPermission &&
                    <div
                        className='popup-footer-remove-button assets-create-file-footer'
                        onClick={() => onDeleteAssetDownloadLink(file.assetMetadataId)}
                    >
                        <FormattedMessage {...DELETE_TEXT} />
                    </div>
                }
            </Popover>
        </div>
    );
});

export default AssetLinkWrapper;
